import dayjs from "dayjs";

function getCurrentMinutesFlooredToNearestFive() {
  const minutes = dayjs().minute();
  const flooredMinutes = Math.floor(minutes / 5) * 5;
  return flooredMinutes;
}

export default getCurrentMinutesFlooredToNearestFive;
